// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cpw-text-base {
  color: #1a1a1a !important;
  line-height: 20px;
  font-size: 16px !important;
  font-family: Source Sans Pro, sans-serif;
  font-weight: normal !important;
}

.c-field__label,
.c-btn,
.panel .c-choice__input+.c-choice__label {
  color: #222 !important;
}


/* Info row layout */
.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 6px;
  margin-bottom: 15px;
  font-size: 14px;
}

/* Info icon color */
.info-icon {
  color: #1e88e5;
  font-size: 18px;
}

/* Input field spacing */
.c-field-control {
  min-height: initial;
  height: 79px;
  display: block;
  width: 100%;
  padding: .85rem 1.15rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #1a1a1a;
}

/* Copy button alignment */
.input-group {
  display: flex;
  justify-content: flex-end;
}

.input-group-btn .btn {
  height: 40px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Optional: make input look clean like mockup */
.margin-bottom-10 {
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/common/share-report-dialog/share-report-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;;;EAGE,sBAAsB;AACxB;;;AAGA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;AACrB","sourcesContent":[".cpw-text-base {\n  color: #1a1a1a !important;\n  line-height: 20px;\n  font-size: 16px !important;\n  font-family: Source Sans Pro, sans-serif;\n  font-weight: normal !important;\n}\n\n.c-field__label,\n.c-btn,\n.panel .c-choice__input+.c-choice__label {\n  color: #222 !important;\n}\n\n\n/* Info row layout */\n.info-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 6px;\n  margin-bottom: 15px;\n  font-size: 14px;\n}\n\n/* Info icon color */\n.info-icon {\n  color: #1e88e5;\n  font-size: 18px;\n}\n\n/* Input field spacing */\n.c-field-control {\n  min-height: initial;\n  height: 79px;\n  display: block;\n  width: 100%;\n  padding: .85rem 1.15rem;\n  font-size: 1rem;\n  line-height: 1.25;\n  color: #1a1a1a;\n}\n\n/* Copy button alignment */\n.input-group {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.input-group-btn .btn {\n  height: 40px;\n  width: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Optional: make input look clean like mockup */\n.margin-bottom-10 {\n  margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
